import {IHttpService} from "frontend-core";
import {IUserService} from "@/services/IUserService";
import {inject, injectable} from "tsyringe";
import {IUserDTO, User} from "@/models/User";

@injectable()
export class UserService implements IUserService {
    constructor(
        @inject("IHttpService")
        private readonly http: IHttpService,
    ) {
    }

    async get(id: string): Promise<User | null> {
        let user: User | null = null;

        await this.http.api.get<IUserDTO>("/users/" + id.replace("/api/users/", ""))
            .then((data) => {
                user = new User(data.data)
            })
            .catch(() => {
                user = null
            });

        return user;
    }

    async block(legacyUserId: string): Promise<void> {
        return this.http.api.put(`/legacy_users/${legacyUserId}/block`, {}, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    async unblock(legacyUserId: string): Promise<void> {
        return this.http.api.put(`/legacy_users/${legacyUserId}/unblock`, {}, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }

    async change(id: string, password: string): Promise<void> {
        return this.http.api.put(`/user/${id}/change_password`, {
            newPassword: password
        });
    }

    async reset(email: string): Promise<void> {
        return this.http.api.post(`/user/reset_password`, {email});
    }
}
